import React, { ReactNode } from 'react'
import styled from '@emotion/styled'
import { CardContent, LinearProgress, Card as MuiCard, Typography } from '@mui/material'

import { spacing } from '@mui/system'

const Card = styled(MuiCard)(spacing)
const Spacer = styled.div(spacing)

/**
 * Formats a Card with a title and children, for detail pages.
 * @param {*} title Title of the card
 * @param {*} loadingElement If non-zero, this is displayed instead of children
 */
export default function InfoBlock({
    title,
    loadingElement = false,
    children,
    noPadding,
}: {
    title: string
    loadingElement?: boolean
    children: ReactNode
    noPadding?: boolean
}) {
    return (
        <Card>
            <CardContent sx={noPadding ? { paddingX: 0, '&:last-child': { paddingBottom: 0 } } : {}}>
                {title && (
                    <>
                        <Typography variant='h6' gutterBottom>
                            {title}
                        </Typography>
                        <Spacer mb={4} />
                    </>
                )}

                {loadingElement ? <LinearProgress /> : children}
            </CardContent>
        </Card>
    )
}
